// extracted by mini-css-extract-plugin
export default {"collapsibleFilter":"_34HxG","title":"_3U-tH"};